import type { SaveGoalArgs } from "@components/Chat/InteractiveTool/types";
import { getOnboardingV3Session } from "@/src/hooks/onboarding/onboardingV3SessionStorage";
import { getSaveGoalDraftIdFromStorage } from "@/src/hooks/onboarding/saveGoalDraftIdStorage";

/** Existing PLANNED marker activation: explicit goalId → args → storage → onboarding session draftId. */
export function resolveGoalIdForActivate(
  args?: Pick<SaveGoalArgs, "goalId">,
  explicitGoalId?: string,
): string | undefined {
  const fromExplicit = explicitGoalId?.trim();
  if (fromExplicit) {
    return fromExplicit;
  }

  const fromArgs = args?.goalId?.trim();
  if (fromArgs) {
    return fromArgs;
  }

  const fromStorage = getSaveGoalDraftIdFromStorage()?.trim();
  if (fromStorage) {
    return fromStorage;
  }

  const fromSession = getOnboardingV3Session()?.planPreview?.draftId?.trim();
  return fromSession || undefined;
}
